import axiosInstance from "./axios.instance";

// OFFICE NOTE
const API_ADD_OFFICENOTE = async (configData) => {
  try {
    const resp = await axiosInstance.post(`/officenote/create`, configData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};
const API_GET_OFFICENOTE = async () => {
  try {
    const resp = await axiosInstance.get(`/officenote`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};
 
//   OFFICE TIME

const API_ADD_OFFICETIME = async (configData) => {
  try {
    const resp = await axiosInstance.post(`/officetime/create`, configData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};
const API_GET_OFFICTIME = async (configData) => {
  try {
    const resp = await axiosInstance.get(`/officetime`, configData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export {
  API_ADD_OFFICENOTE,
  API_GET_OFFICENOTE,
  API_ADD_OFFICETIME,
  API_GET_OFFICTIME,
};
